/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const QuotationStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  waiting: {
    name: 'ตรวจสอบราคา',
    color: 'primary',
    icon: 'price_check',
  },
  quotation: {
    name: 'เสนอราคา',
    color: 'info',
    icon: 'task_alt',
  },
  revise: {
    name: 'เปลี่ยนราคา',
    color: 'info',
    icon: 'task_alt',
  },
  reject: {
    name: 'ลูกค้าปฏิเสธ',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  success: {
    name: 'ลูกค้าสั่งซื้อ',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default QuotationStatus;
